import { POLICY_JOINT_POLICYHOLDER_PAGE_URL } from "../routing/routes.config";

export function tagIfJointPolicyHolder(name: string): string {
  const currentPath = window.location.pathname;
  const expectedPath = POLICY_JOINT_POLICYHOLDER_PAGE_URL;
  const postfixTag = expectedPath.split("/")[expectedPath.split("/").length - 1];
  return currentPath !== expectedPath ? name : name + `_${postfixTag}`;
}
